export default "__VITE_ASSET__df0d245e__"